import { render, staticRenderFns } from "./DeletableAvatar.vue?vue&type=template&id=f4a23c2c&scoped=true&"
import script from "./DeletableAvatar.vue?vue&type=script&lang=js&"
export * from "./DeletableAvatar.vue?vue&type=script&lang=js&"
import style0 from "./DeletableAvatar.vue?vue&type=style&index=0&id=f4a23c2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4a23c2c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
